/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=a18816d0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a18816d0&lang=scss"

import exportComponent from "/data/repos/231_20260317161619/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__